import { useCurrency } from "@/context/CurrencyContext";

export default function CurrencyPicker({ compact = false }) {
    const { currency, setCurrency } = useCurrency();
    return (
        <select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className={`rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-emerald-400 ${compact ? "text-xs px-2 py-1" : "text-sm px-2.5 py-1.5"}`}
            aria-label="Currency"
        >
            <option value="USD">$ USD</option>
            <option value="CAD">CA$ CAD</option>
            <option value="EUR">€ EUR</option>
        </select>
    );
}
